import React from 'react';
import { isMobile } from '../../global/ScreenSizeHelper';
import Transition from './../../transition';
import TopicOne from './Topic-One'
import TopicThree from './Topic-Three'
import TopicFour from './Topic-Four'
import TopicTwo from './Topic-Two'
import HomeFooter from './HomeFooter'

export const Home = () => {

    return (
        <>
            <TopicOne />
            <TopicThree />
            <TopicTwo />
            <TopicFour />
            {/* {!isMobile && <HomeFooter />} */}
        </>
    )
}

export default Transition(Home)